if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class StickyAtc extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          prodTitle: ".m-sticky-addtocart--title",
          mainImage: ".m-sticky-addtocart--image",
          addToCart: ".m-add-to-cart",
          buyNowBtn: ".m-product-dynamic-checkout",
          variantIdSelect: '[name="id"]',
          foxkitBtn: ".foxkit-button",

          mobileVariantPicker: "[data-mobile-variant-picker]",
          mobileVariantTrigger: "[data-mobile-variant-trigger]",
          mobileVariantPanel: "[data-mobile-variant-panel]",
          mobileVariantOption: "[data-variant-id]",
          mobileVariantSelected: "[data-mobile-variant-selected]",
        };

        this.hasCustomFields = !!document.querySelector(
          ".m-main-product--info .m-product-custom-field"
        );

        this.mobileVariantSelected = false;
      }

      connectedCallback() {
        this.container = this.closest(".m-sticky-addtocart");
        this.mainProductForm = document.querySelector(".m-product-form--main");
        this.mainProductInfo = document.querySelector(".m-main-product--info");

        this.mainAddToCart =
          this.mainProductForm?.querySelector(".m-add-to-cart");

        this.mainDynamicCheckout =
          this.mainProductForm?.querySelector(this.selectors.buyNowBtn);

        this.productId = this.dataset.productId;

        this.selectedVariantDefault =
          this.dataset.disableSelectedVariantDefault === "true";

        this.domNodes = queryDomNodes(this.selectors, this.container);

        this.variantData = this.getVariantData();

        const queryString = window.location.search;
        const hasQueryString = queryString.includes("?variant=");

        if (
          !hasQueryString &&
          this.selectedVariantDefault &&
          this.variantData &&
          this.variantData.length > 1
        ) {
          this.disableSelectedVariantDefault();
        }

        this.init();
        this.initMobileVariantPicker();
        this.setStickyAddToCartHeight();

        this.addEventListener("change", () => {
          const variantSelect = this.querySelector(
            this.selectors.variantIdSelect
          );

          if (!variantSelect) return;

          const selectedVariantId = variantSelect.value;

          this.currentVariant = this.variantData.find(
            (variant) => variant.id === Number(selectedVariantId)
          );

          this.updateButton(true, "", false);

          if (!this.currentVariant) {
            this.updateButton(true, "", true);
          } else {
            this.updateButton(
              !this.currentVariant.available,
              window.MinimogStrings.soldOut
            );
          }
        });

        document.addEventListener("matchMobile", () => {
          this.setStickyAddToCartHeight();
        });

        document.addEventListener("unmatchMobile", () => {
          this.setStickyAddToCartHeight();
        });
      }

      getVariantData() {
        this.variantData =
          this.variantData ||
          JSON.parse(
            this.container.querySelector('[type="application/json"]').textContent
          );

        return this.variantData;
      }

      init() {
        if (!this.mainAddToCart) {
          this.container.style.setProperty("--m-translate-y", 0);
          return;
        }

        const {
          prodTitle,
          mainImage,
          addToCart,
          buyNowBtn,
          foxkitBtn,
        } = this.domNodes;

        if (buyNowBtn) {
          this.enable_dynamic_checkout = true;
        }

        const headerHeight = MinimogSettings.headerHeight || 66;
        const rootMargin = `${headerHeight}px 0px 0px 0px`;

        if ("IntersectionObserver" in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.intersectionRatio !== 1) {
                  this.container.style.setProperty(
                    "--m-translate-y",
                    0
                  );
                } else {
                  this.container.style.setProperty(
                    "--m-translate-y",
                    "100%"
                  );
                }

                document.documentElement.classList[
                  entry.intersectionRatio !== 1 ? "add" : "remove"
                ]("stick-atc-show");
              });
            },
            {
              threshold: 1,
              rootMargin,
            }
          );
        }

        if (prodTitle) {
          prodTitle.addEventListener("click", () => __scrollToTop());
        }

        if (mainImage) {
          mainImage.addEventListener("click", () => __scrollToTop());
        }

        if (this.hasCustomFields) {
          let hasCustomFieldRequired = false;

          const customFields = document.querySelectorAll(
            ".m-main-product--info .m-product-custom-field"
          );

          customFields &&
            customFields.forEach((item) => {
              const field = item.querySelector(".form-field");

              if (
                field.value == "" &&
                field.hasAttribute("required")
              ) {
                hasCustomFieldRequired = true;
              }
            });

          if (hasCustomFieldRequired && addToCart) {
            addToCart.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();

              __scrollToTop(
                this.mainProductForm,
                () => this.mainAddToCart.click()
              );
            });
          }

          if (buyNowBtn) {
            buyNowBtn.addEventListener(
              "click",
              (e) => {
                const missing = validateForm(this.mainProductInfo);

                if (missing.length > 0) {
                  e.preventDefault();
                  e.stopPropagation();

                  __scrollToTop(
                    this.mainProductForm,
                    () => this.mainDynamicCheckout.click()
                  );
                }
              },
              true
            );
          }

          if (foxkitBtn) {
            foxkitBtn.addEventListener("click", (e) => {
              e.preventDefault();

              __scrollToTop(
                this.mainProductForm,
                () => this.mainAddToCart.click()
              );
            });
          }
        }

        this.setObserveTarget();
        this.syncWithMainProductForm();
      }

  initMobileVariantPicker() {
    const picker = this.querySelector(
      this.selectors.mobileVariantPicker
    );

    const trigger = this.querySelector(
      this.selectors.mobileVariantTrigger
    );

    const addButton = this.querySelector(
      this.selectors.addToCart
    );

    const variantSelect = this.querySelector(
      this.selectors.variantIdSelect
    );

    if (!picker || !trigger || !addButton || !variantSelect) {
      return;
    }
    const hasMultipleVariants = this.variantData?.length > 1;

    if (!hasMultipleVariants) {
      this.mobileVariantSelected = true;

      return;
    }

    const variantOptions = picker.querySelectorAll(
      this.selectors.mobileVariantOption
    );

    trigger.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();

      if (window.innerWidth > 767) {
        return;
      }

      const isOpen = picker.classList.contains("is-open");

      picker.classList.toggle("is-open", !isOpen);

      trigger.setAttribute(
        "aria-expanded",
        String(!isOpen)
      );

      this.container.classList.toggle(
        "mobile-picker-open",
        !isOpen
      );

      this.setStickyAddToCartHeight();
    });

    variantOptions.forEach((option) => {
      option.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();

        const variantId = option.dataset.variantId;

        if (!variantId) {
          return;
        }

        variantSelect.value = variantId;

        variantSelect.dispatchEvent(
          new Event("change", {
            bubbles: true,
          })
        );

        variantOptions.forEach((item) => {
          item.classList.remove("is-selected");
        });

        option.classList.add("is-selected");

        const selectedLabel = this.querySelector(
          this.selectors.mobileVariantSelected
        );

        if (selectedLabel) {
          selectedLabel.textContent =
            `${option.dataset.variantTitle} - ${option.dataset.variantPrice}`;
        }

        this.mobileVariantSelected = true;

        picker.classList.remove("is-open");

        trigger.setAttribute("aria-expanded", "false");

        this.container.classList.remove(
          "mobile-picker-open"
        );

        this.setStickyAddToCartHeight();
      });
    });

    addButton.addEventListener("click", (event) => {
      if (window.innerWidth > 767) {
        return;
      }

      if (!this.mobileVariantSelected) {
        event.preventDefault();
        event.stopPropagation();

        picker.classList.add("is-open");

        trigger.setAttribute("aria-expanded", "true");

        this.container.classList.add(
          "mobile-picker-open"
        );

        this.setStickyAddToCartHeight();
      }
    });

    document.addEventListener("click", (event) => {
      if (
        !picker.contains(event.target) &&
        !trigger.contains(event.target)
      ) {
        picker.classList.remove("is-open");

        trigger.setAttribute("aria-expanded", "false");

        this.container.classList.remove(
          "mobile-picker-open"
        );

        this.setStickyAddToCartHeight();
      }
    });
  }




      setObserveTarget() {
        if (this.observer) {
          this.observer.observe(this.mainProductForm);
          this.observeTarget = this.mainProductForm;
        }
      }

      checkDevice(e) {
        const sectionHeight = this.clientHeight + "px";

        document.documentElement.style.setProperty(
          "--f-sticky-atc-bar-height",
          sectionHeight
        );
      }

      disableSelectedVariantDefault() {
        const pickerSelects = this.querySelector(
          ".m-product-option--dropdown-select"
        );

        if (!pickerSelects) return;

        pickerSelects.value = "";
      }

      updateButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector(".sticky-atc-form");

        if (!productForm) return;

        const addButton = productForm.querySelector('[name="add"]');

        const addButtonText = productForm.querySelector(
          '[name="add"] > .m-add-to-cart--text'
        );

        if (!addButton) return;

        if (disable) {
          addButton.setAttribute("disabled", "disabled");

          if (text && addButtonText) {
            addButtonText.textContent = text;
          }
        } else {
          addButton.removeAttribute("disabled");

          addButton.classList.remove("disabled");

          if (addButtonText) {
            addButtonText.textContent =
              window.MinimogStrings.addToCart;
          }
        }
      }

      syncWithMainProductForm() {
        const variantInput = this.querySelector('[name="id"]');

        if (!variantInput) return;

        window.MinimogEvents.subscribe(
          `${this.productId}__VARIANT_CHANGE`,
          async (variant) => {
            if (variant) {
              variantInput.value = variant.id;

              this.mobileVariantSelected = true;

              const pickerOptions = this.querySelectorAll(
                this.selectors.mobileVariantOption
              );

              pickerOptions.forEach((option) => {
                option.classList.toggle(
                  "is-selected",
                  Number(option.dataset.variantId) === variant.id
                );
              });
            }
          }
        );
      }

      setStickyAddToCartHeight() {
        document.documentElement.style.setProperty(
          "--f-sticky-atc-bar-height",
          this.offsetHeight + "px"
        );

        window.MinimogSettings.stickyAddToCartHeight =
          this.offsetHeight;
      }
    }
  );
}